import { cfg } from 'config/runtimeConfig'
interface ActionQuickFormProps {
  entityId: string
  type: 'tax' | 'quote' | 'invoice'
  onSuccess?: (msg: string) => void
  onCancel?: () => void
}

const LEGACY_BASE = (cfg('REACT_APP_LEGACY_BASE_URL') ?? '').replace(/\/+$/, '')

const META: Record<
  ActionQuickFormProps['type'],
  { title: string; hint: string; button: string; url: (entityId: string) => string }
> = {
  tax: {
    title: 'Tax Settings',
    hint: 'Tax settings are maintained on the legacy Kit19 page. It opens in a new tab.',
    button: 'Open Tax Settings',
    url: () => `${LEGACY_BASE}/UserCRMCampaign/Invoice/leadtaxsetting.aspx`,
  },
  quote: {
    title: 'Quotations',
    hint: 'Quotations for this lead are managed on the legacy Kit19 page. It opens in a new tab.',
    button: 'Open Quotations',
    url: (entityId) => `${LEGACY_BASE}/UserCRMCampaign/Invoice/quotationList.aspx?LeadId=${entityId}`,
  },
  invoice: {
    title: 'Invoices',
    hint: 'Invoices for this lead are managed on the legacy Kit19 page. It opens in a new tab.',
    button: 'Open Invoices',
    url: (entityId) => `${LEGACY_BASE}/UserCRMCampaign/Invoice/invoicelist.aspx?LeadId=${entityId}`,
  },
}

/**
 * The legacy edit page linked to the Invoice module's .aspx screens for tax,
 * quotation and invoice — no in-page form. This keeps that behaviour.
 */
export function TaxQuoteInvoiceForm({ entityId, type }: ActionQuickFormProps) {
  const meta = META[type]

  return (
    <div className="action-form">
      <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 15 }}>{meta.title}</div>
      <div className="form-hint" style={{ marginBottom: 16 }}>
        {meta.hint}
      </div>
      <button type="button" className="btn pri-btn" onClick={() => window.open(meta.url(entityId), '_blank')}>
        {meta.button}
      </button>
    </div>
  )
}
